import { render, staticRenderFns } from "./merLink.vue?vue&type=template&id=5ac4a4c3&scoped=true&"
import script from "./merLink.vue?vue&type=script&lang=js&"
export * from "./merLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac4a4c3",
  null
  
)

export default component.exports